import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Compbaser } from "../../../components/compbaser";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { mimeSwap } from "../../../common";
import { IBlockLabelsRecords } from "../scene-blocks/block-constants";
import { TranslocoService } from "@ngneat/transloco";
import { IAppStatic, Id, ISceneTemplate } from "../../../interfaces";
import { StoreSelectorsService } from "../../../services";
import { IDialogGetAsset } from "../../../components/dialog-get-asset/dialog-get-asset.component";
import { sceneTemplates } from "../../../../assets/accountTemplates/scene-template-constants";
import { DialogImportSceneComponent } from '../../../components/dialog-import-scene/dialog-import-scene.component';
import { debounce } from "utils-decorators";
import { Plugin } from "@egjs/ngx-flicking";
import { Arrow } from "@egjs/flicking-plugins";
import { faCircleChevronLeft, faCircleChevronRight } from "@fortawesome/free-solid-svg-icons";
import * as _ from 'lodash';

interface ITemplateByCategory {
    folder: string;
    count: number;
    plugins: Plugin[];
    items: Array<ISceneTemplate>;
}

@Component({
    selector: 'app-scene-importer',
    templateUrl: './scene-importer.component.html',
    styleUrls: ['./scene-importer.component.scss'],
    standalone: false
})
export class SceneImporterComponent extends Compbaser implements OnInit {
    
    readonly faArrowLeft = faCircleChevronLeft;
    readonly faArrowRight = faCircleChevronRight;
    readonly largeCategories =  ["Presentation"];
    readonly firstOrderCategories = ["Presentation"];

    @Input() autoOpenOnImport = false;

    @Input()
    set dialogGetAsset(i_dialogGetAsset: IDialogGetAsset) {
        this.m_dialogGetAsset = i_dialogGetAsset;
        
        if (this.m_dialogGetAsset) {
            this.mimeTypeLong = this.m_dialogGetAsset?.mimeType;
            this.categories = this.m_dialogGetAsset?.filteredCategories || [];
            this.initMimeShort();
            this.clearSelection();
            // this.composeTemplate(this.mimeTypeLong, this.categories);
        } else {
            this.cod(
                this.route.paramMap.subscribe((routeParams) => {
                    this.mimeTypeLong = routeParams.get('mime');
                    this.initMimeShort();
                    this.clearSelection();
                    // this.composeTemplate(this.mimeTypeLong, null);
                })
            );
        }
    }

    @Output() itemSelected = new EventEmitter<string>();

    loading = true;
    appSettings: IAppStatic;
    filter = '';
    importDialog;
    m_checkedAutoOpenModel = true;
    m_dialogGetAsset: IDialogGetAsset;
    m_sceneTemplates: Array<ISceneTemplate> = [];
    mimeTypeLong;
    mimeTypeShort;
    categories;
    blockLabelRecords: IBlockLabelsRecords;
    selectedScene: ISceneTemplate = {
        sceneName: 'empty',
        sceneTitle: 'new scene',
        sceneId: '-1',
        nativeId: '-1',
        businessId: '-1',
        width: '1920',
        height: '1080',
        mimeType: '',
        url: '',
        childSceneIds: '',
        thumbs: []
    };

    initialCount = 20;
    moreCount = 10;
    verticalInitialCount = 15;
    verticalMoreCount = 5;

    allTemplatesByCategories: Array<ITemplateByCategory> = [];
    currentTemplates: Array<ITemplateByCategory> = [];

    throttle = 300;
    scrollDistance = 2;

    flickConfig = {
        gap: 10,
        infinite: true,
        circular: false,
        infiniteThreshold: 100,
        align: 'prev',
        // moveType: 'freeScroll',
        renderOnlyVisible: false,
        // nested: false
    }

    constructor(
        private translocoService: TranslocoService,
        private storeSelector: StoreSelectorsService,
        protected override dialog: MatDialog,
        private router: Router,
        private route: ActivatedRoute) {
        super(dialog);
        this.cod(
            storeSelector.getAppSettings()
                .subscribe((appSettings: IAppStatic) => {
                    this.appSettings = appSettings;
                })
        );
    }

    ngOnInit() {
        this.blockLabelRecords = this.storeSelector.blockLabels;
    }

    private initMimeShort() {
        let mimeTypeShort = mimeSwap('longToShort', this.mimeTypeLong); // === 'None' ? '' : mimeSwap('longToShort', this.mimeTypeLong);
        if (!mimeTypeShort) return;
        mimeTypeShort = this.translocoService.translate(`general.${mimeTypeShort}`, {}, this.translocoService.getActiveLang());
        this.mimeTypeShort = mimeTypeShort.split(' ')[0];
    }

    composeTemplate(mimeTypeLong: string, categories: Array<string>) {
        if (!mimeTypeLong) this.mimeTypeShort = '';
        this.m_sceneTemplates = [];
        if (mimeTypeLong) {
            const mimeTypeLongs: Array<string> = this.storeSelector.getBlockLabelByMimeType(mimeTypeLong, false).types;
            // tslint:disable-next-line
            for (const sceneName in sceneTemplates) {
                const sceneConfig = sceneTemplates[sceneName];
                if (mimeTypeLongs.findIndex((v) => v === sceneConfig[3]) === -1) continue;
                this.m_sceneTemplates.push({
                    nativeId: sceneConfig[2] as any,
                    sceneTitle: sceneConfig[4].name,
                    sceneId: sceneConfig[2] as any,
                    sceneName,
                    height: '',
                    width: '',
                    mimeType: sceneConfig[3],
                    businessId: sceneConfig[0] as any,
                    url: `./assets/images/scenes/${sceneName}.jpg`,
                    folder: sceneConfig[4].folder,
                    childSceneIds: sceneConfig[4].sceneIds
                });
            }
        } else if (categories) {
            // tslint:disable-next-line
            for (const sceneName in sceneTemplates) {
                const sceneConfig = sceneTemplates[sceneName];
                const idx = categories.findIndex(v => v === sceneConfig[4].folder);
                if (idx === -1) continue;
                this.m_sceneTemplates.push({
                    nativeId: categories[idx],
                    sceneTitle: sceneConfig[4].name,
                    sceneId: sceneConfig[2] as any,
                    height: '',
                    width: '',
                    mimeType: sceneConfig[3],
                    sceneName,
                    businessId: sceneConfig[0] as any,
                    url: `./assets/images/scenes/${sceneName}.jpg`,
                    folder: sceneConfig[4].folder,
                    childSceneIds: sceneConfig[4].sceneIds
                });
            }
        }
        this.composeFlicking();
    }

    @debounce(333)
    applyFilter(filterValue: string) {
        this.composeTemplate(this.mimeTypeLong, this.categories);
        this.m_sceneTemplates = this.m_sceneTemplates.filter((v) => {
            const s = `${v.sceneTitle} ${v.sceneName} ${v.mimeType}`.toLowerCase();
            return s.match(filterValue.toLowerCase());
        });
        this.composeFlicking();
        this.loading = false;
    }

    clearSelection() {
        this.filter = '';
        this.applyFilter('');
    }

    private composeFlicking() {
        // initial template items
        this.allTemplatesByCategories = [];
        this.m_sceneTemplates.forEach((_temp) => {
            const template = _temp;

            const folder = template.folder;
            const ind = this.allTemplatesByCategories.findIndex((v) => v.folder == folder);

            if (ind > -1) {
                if (this.allTemplatesByCategories[ind].items.length < this.initialCount) {
                    this.allTemplatesByCategories[ind].items.push(_temp);
                }
                this.allTemplatesByCategories[ind].count += 1;
            } else {
                this.allTemplatesByCategories.push({
                    folder: folder,
                    count: 1,
                    plugins: [new Arrow({ moveCount: 4 })],
                    items: [_temp]
                })
            }
        });

        // Sort categories templates by alphabetical
        this.allTemplatesByCategories.sort((a, b) => {
            if (this.firstOrderCategories.includes(a.folder)) return -1;
            if (this.firstOrderCategories.includes(b.folder)) return 1;
            return a.folder.toLowerCase().localeCompare(b.folder.toLowerCase());
        });

        this.currentTemplates = this.allTemplatesByCategories.slice(0, this.verticalInitialCount);
    }

    /** Load more template items whenever slider slide ends */
    moreTemplateItems(folder) {
        const templates = this.allTemplatesByCategories.find((v) => v.folder == folder);
        if (!templates) return;

        let currentCount = templates.items.length;
        let cnt = 0;
        for (const template of this.m_sceneTemplates) {
            if (folder != template.folder) continue;

            cnt++;
            if (cnt <= currentCount) {
                continue;
            }
            if (cnt > currentCount + this.moreCount) {
                break;
            }

            templates.items.push(template);
        }
    }

    /** Load more template categories when scroll down */
    moreTemplateCategories() {
        const cnt = this.currentTemplates.length;
        if (cnt < this.allTemplatesByCategories.length) {
            this.currentTemplates.push(...this.allTemplatesByCategories.slice(cnt, cnt + this.verticalMoreCount));
        }
    }

    openImportDialog(i_scene: ISceneTemplate) {
        if (_.isNull(i_scene)) {
            return;
        }
        this.selectedScene = i_scene;
        this.selectedScene.url = `${this.appSettings.cloudResourcesS3}/business1000/resources/scenes_snaps/${this.selectedScene.sceneName}.png`;
        if (this.selectedScene.folder === "Presentation") {            
            this.selectedScene.thumbs = this.extractThumbs(this.selectedScene.businessId, this.selectedScene.childSceneIds);
        }

        this.importDialog = this.dialog.open(DialogImportSceneComponent, {
            width: "600px",
            data: {
                template: this.selectedScene,
                showDownloadingCancel: true,
                routerAfterImport: false
            },
            disableClose: true
        });

        this.importDialog.afterClosed().subscribe(result => {
            if (!result) return;
            if (this.m_dialogGetAsset) {
                this.itemSelected.emit(result);
            }
    
            setTimeout(() => {
                if (this.autoOpenOnImport && this.m_checkedAutoOpenModel) {
                    this.router.navigateByUrl(`editor/scene/${result}`);
                }
            }, 500);
        });
    }

    private extractThumbs(businessId, sceneIds) {
        if (!businessId || !sceneIds || sceneIds.split((/[ ,]+/)).length == 0) {
            return [];
        }

        const ids: Id[] = sceneIds.split((/[ ,]+/));
        const thumbs = [];
        Object.keys(sceneTemplates).forEach((sceneName) => {
            const temp = sceneTemplates[sceneName];
            if (temp[0] === businessId && ids.includes(`${temp[2]}`)) {
                const url = `${this.appSettings.cloudResourcesS3}/business1000/resources/scenes_snaps/${sceneName}.png`;
                if (temp[4].folder === "Presentation") {
                    thumbs.unshift(url);
                } else {
                    thumbs.push(url);
                }
            }
        });
        return thumbs;
    }
}

